export const isPrefixedId = (value: string): boolean => {
    return /^e_\d+$/.test(value)
}

export const isArticleId = (value: string): boolean => {
    return isPrefixedId(value);
}

export const isStoreId = (value: string): boolean => {
    return isPrefixedId(value);
}

export const isWebcode = (value: string): boolean => {
    return /^\d{11}$/.test(value);
}